var _path, _g, _path2, _tspan, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgResumeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28.594 35.42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.397.397h25.8v26.95l-7.675 7.676H1.397Z",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.794
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.12855 0 0 1.12855 -32.31 -197.317)",
    fill: "#fff",
    paintOrder: "stroke markers fill"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.146 186.498a3.448 3.448 0 0 0-1.733-2.991 3.448 3.448 0 0 0-3.457.015 3.448 3.448 0 0 0-1.706 3.007l3.448-.03z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35.698,
    cy: 181.511,
    r: 2.346
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.297 17.797h19.8M4.297 21.697h19.8M4.297 25.947h10.55M4.297 30.198h10.55",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.198
  })), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      lineHeight: 1.25
    },
    x: 69.226,
    y: 194.087,
    fontWeight: 400,
    fontSize: 7.92,
    fontFamily: "sans-serif",
    letterSpacing: 0,
    wordSpacing: 0,
    fill: "#fff",
    strokeWidth: 0.198,
    transform: "translate(-55.677 -182.169)"
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 69.226,
    y: 194.087
  }, "CV"))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.522 35.023v-7.707",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.198
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.197 27.347h-7.675v7.676",
    fill: "none",
    stroke: "#fffefe",
    strokeWidth: 0.794,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResumeIcon);
export default __webpack_public_path__ + "static/media/resume-icon.c351861a947f1f27af3757997c74b60a.svg";
export { ForwardRef as ReactComponent };